import { utils, writeFileXLSX } from 'xlsx';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// Función para obtener imagen Base64 para el logo del PDF
export const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
};

export function useTableExport() {
    
    const exportTableData = async ({ ext, data, columns, modulo = 'Data', titleExport = null, showIndex = false, showTotales = false }) => {
        const expItems = data;
        const expFields = columns.filter(col => !col.noexport && col.key !== 'actions');

        // Funciones auxiliares sincronizadas con TableFilter.vue
        const isDateColumn = (col, value) => {
            if (col?.filterType === 'date' || col?.filterType === 'datetime') return true;
            if (!value) return false;
            const key = col?.key || '';
            const isAtKey = key.toLowerCase().endsWith('_at');
            const isIsoDate = typeof value === 'string' && value.includes('-') && !isNaN(Date.parse(value));
            return isAtKey || isIsoDate;
        };

        const autoFormatDate = (val, fieldType) => {
            const d = new Date(val);
            if (isNaN(d.getTime())) return val;
            const day = d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
            if (fieldType === 'datetime') {
                const hour = d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', hour12: true }).replace(/\./g, '');
                return `${day} ${hour}`;
            }
            return day;
        };

        const getBooleanText = (column, value) => {
            if (column.booleanLabels) {
                return value === 1 ? column.booleanLabels.true : column.booleanLabels.false;
            }
            const activeKeys = ['status', 'active', 'estado', 'visible'];
            if (activeKeys.includes(column.key)) {
                return value === 1 ? 'ACTIVO' : 'INACTIVO';
            }
            return value === 1 ? 'SI' : 'NO';
        };

        const getFieldValue = (client, field) => {
            let val = client[field.key];
            
            // 1. Manejo de Booleans
            if (field.isBoolean) {
                return getBooleanText(field, val);
            }

            // 2. Manejo de Select / Select-Search (Mapeo de IDs a Labels)
            if (field.filterOptions) {
                const option = field.filterOptions.find(opt => String(opt.value) === String(val));
                return option ? (option.label ?? '') : '-';
            }

            // 3. Manejo de Fechas
            if (val && isDateColumn(field, val)) {
                return autoFormatDate(val, field.fieldType);
            }

            // 4. Default
            return val !== null && val !== undefined && val !== '' ? val : '-';
        };

        if (ext === 'xlsx') {
            const dataExport = [];
            expItems.forEach((client, index) => {
                dataExport[index] = {};
                expFields.forEach(field => {
                    dataExport[index][field.label] = getFieldValue(client, field);
                });
            });

            const ws = utils.json_to_sheet(dataExport);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, 'Data');
            writeFileXLSX(wb, modulo + 'Report.xlsx');

        } else if (ext === 'pdf') {
            try {
                pdfMake.vfs = pdfFonts.pdfMake.vfs;

                let dataExport = [];
                dataExport[0] = [];

                let factorCol = 0;
                if (showIndex) {
                    factorCol = 1;
                    dataExport[0][0] = '#';
                }

                expFields.forEach((field, index) => {
                    dataExport[0][index + factorCol] = field.label || field.key || '';
                });

                var totales = { 'ttc': 0 };
                let lastLine = 0;

                expItems.forEach((client, index) => {
                    dataExport[index + 1] = [];

                    if (factorCol) {
                        dataExport[index + 1][0] = index + 1;
                    }

                    expFields.forEach((field, index2) => {
                        let val = getFieldValue(client, field);
                        
                        // Prevención estricta contra Undefined (pdfMake crashea si ve null o undefined)
                        if (val === undefined || val === null) val = '-';
                        if (typeof val !== 'string' && typeof val !== 'number') val = String(val);

                        dataExport[index + 1][index2 + factorCol] = val;
                        // Lógica original de totales
                        if (showTotales && field.type === 'number' && typeof val === 'number' && field.key === 'total_ttc') {
                            totales.ttc += parseFloat(val);
                        }
                    });
                });

                lastLine = dataExport.length;
                if (showTotales) {
                    dataExport[lastLine] = [];
                    if (factorCol) {
                        dataExport[lastLine][0] = ''; // <--- Prevención de array hole
                    }
                    expFields.forEach((field, index3) => {
                        if (field.type === 'number' && field.key === 'total_ttc') {
                            dataExport[lastLine][index3 + factorCol] = totales.ttc;
                        } else {
                            dataExport[lastLine][index3 + factorCol] = '\t';
                        }
                    });
                }

                let colWith = [];
                if (factorCol) colWith[0] = 'auto';
                for (let i = 0; i < expFields.length; i++) {
                    colWith[i + factorCol] = 'auto';
                }

                let pageOrientation = 'portrait';
                if (colWith.length > 8 || modulo === 'cobranzas') {
                    pageOrientation = 'landscape';
                }

                const nowDate = new Date();
                const fechaHoy = nowDate.toLocaleDateString('es-ES');

                // Logo de cabecera de la escuela
                let logoImage = null;
                try {
                    logoImage = await getBase64ImageFromURL("/documents/mycompany/logos/logomembrete.png");
                } catch (e) {
                    console.warn("Logo no encontrado");
                }

                let headerColumns = [];
                if (logoImage) {
                    headerColumns.push({
                        margin: [40, 0, 0, 0],
                        image: logoImage,
                        width: 40
                    });
                }
                headerColumns.push({
                    margin: [-30, 0, 0, 0],
                    text: ' \n \n\n' + (titleExport ?? 'Total ' + modulo + ' : ' + expItems.length),
                    alignment: 'center',
                    style: 'header'
                });

                var docDefinition = {
                    pageSize: (colWith.length > 14 ? 'A3' : 'A4'),
                    pageOrientation: pageOrientation,
                    pageMargins: [40, 80, 40, 50],
                    header: {
                        margin: 10,
                        columns: headerColumns
                    },
                    footer: function (currentPage, pageCount) { 
                        return [{ text: 'Fecha de consulta: ' + fechaHoy + ', Pag. ' + currentPage.toString() + ' de ' + pageCount, alignment: 'right', margin: [0, 0, 40, 0] }]; 
                    },
                    content: [
                        {
                            layout: 'lightHorizontalLines',
                            table: {
                                headerRows: 1,
                                widths: colWith,
                                body: dataExport
                            }
                        }
                    ],
                    styles: {
                        header: {
                            fontSize: 11,
                            bold: true
                        }
                    },
                    defaultStyle: {
                        fontSize: 9,
                        bold: false
                    }
                };

                pdfMake.createPdf(docDefinition).download(modulo + 'Report');
            } catch (error) {
                console.error("Error crítico generando el documento PDF:", error);
                alert("Hubo un error interno al generar el Documento PDF: " + error.message);
            }
        }
    };

    return { exportTableData };
}
